import {needAuth} from "../instance/Instance";
import {getPages} from "../../components/commonmethod/CommonMethod";

/**
 * 통합대시보드
 * */

//유지관리 업무현황
async function getMaintenancece(querySelector) {
    const search ={
        querySelector:querySelector
    }
    // const r3es= await needAuth.post('/statics/total/maintenance',search);
    try{
        return  await needAuth.post('/statics/total/maintenance',search);
    }catch (error){
        return error;
    }
}

//통합2번째
async function getMaintenanceceDetail() {
    try{
        return  await needAuth.get('/statics/total/maintenance-detail');
    }catch (error){
        return error;
    }
}

//작업 달력
async function getTaskCalendar(search) {
    try{
        return  await needAuth.post('/statics/total/task-calendar', search);
    }catch (error){
        return error;
    }
}


//작업 달력 업무목록
async function getTaskCalendarList(search) {
    try{
        return  await needAuth.post('/statics/total/task-calendar/list', search);
    }catch (error){
        return error;
    }
}


//점검, 장애, 작업 처리현황
async function getProcessCumulative(search) {
    try{
        return  await needAuth.post('/statics/total/cumulative', search);
    }catch (error){
        return error;
    }
}
//유지보수 업무준수율
async function getKeepingRate(search) {
    try{
        return  await needAuth.post('/statics/total/keep', search);
    }catch (error){
        return error;
    }
}

//접수신청 처리현황
async function getServiceCurrent(search) {
    try{
        return  await needAuth.post('/statics/total/service', search);
    }catch (error){
        return error;
    }
}

//월간 장애비율
async function getInDecreaseRateOfError(search) {
    try{
        const resonse = await needAuth.post('/statics/total/increase-decrease', search);
        return  resonse;
    }catch (error){
        return error;
    }
}

//당월 장애분포도
async function getSpreadOfError() {
    try{
        return  await needAuth.get('/statics/total/error-spread');
    }catch (error){
        return error;
    }
}

//공지사항
async function getNotice() {
    try{
        return  await needAuth.get('/statics/notice');
    }catch (error){
        return error;
    }
}


/**
 * 자산대시보드
 * */


//자산종합관리
async function getAsseCurrent(search) {
    try{
        return  await needAuth.post('/statics/asset/current', search);
    }catch (error){
        return error;
    }
}



//감가상각/EOS
async function getDepreciation() {
    try{
        return  await needAuth.get('/statics/depreciation');
    }catch (error){
        return error;
    }
}

//자산계약관리
async function getContract(search) {
    try{
        return  await needAuth.post('/statics/contract', search);
    }catch (error){
        return error;
    }
}

//자산유형별 현황
async function getAssetByType() {
    try{
        return  await needAuth.get('/statics/asset/type');
    }catch (error){
        return error;
    }
}


async function getAssetByParentId(topId,parentId, pageInfo) {
    try{
        return  await needAuth.get(`/statics/asset/type/${topId}/${parentId}?`+ getPages(pageInfo));
    }catch (error){
        return error;
    }
}

async function getAssetByCodeId(codeId, pageInfo) {
    try{
        return  await needAuth.get(`/statics/asset/${codeId}?`+ getPages(pageInfo));
    }catch (error){
        return error;
    }
}

async function getAssetByDepartment(parentId, pageInfo) {
    try{
        const params = getPages(pageInfo);
        const url = parentId
            ? `/statics/asset/department?parentId=${parentId}&${params}`
            : `/statics/asset/department?${params}`;

        return await needAuth.get(url);
    }catch (error){
        return error;
    }
}

async function getAssetByProject(id, pageInfo) {
    try{
        const params = getPages(pageInfo);
        const url = id
            ? `/statics/asset/project?id=${id}&${params}`
            : `/statics/asset/project?${params}`;

        return await needAuth.get(url);
    }catch (error){
        return error;
    }
}

async function getDataByParentIdAndTableName(parentId, pageInfo, table, type, startDate, endDate) {
    let search = {
        parentId : parentId,
        table : table,
        type : type,
        startDate : startDate,
        endDate : endDate
    }
    try{
        return  await needAuth.post(`/statics/maintenance/chartAndData?`+getPages(pageInfo), search);
    }catch (error){
        return error;
    }
}

//자산 라이선스 관리
async function getSimmsLicense(search) {
    try{
        return  await needAuth.get('/statics/simms/license');
    }catch (error){
        return error;
    }
}

//실사관리
async function getAssetDiligence(search) {
    try{
        return  await needAuth.post('/statics/asset/diligence', search);
    }catch (error){
        return error;
    }
}

async function getAssetLifeCycle(search) {
    try{
        return  await needAuth.post('/statics/asset/lifecycle', search);
    }catch (error){
        return error;
    }
}

//자산관리 내역
async function getAssetHistory(search) {

    try{
        return  await needAuth.post('/statics/asset/history', search);
    }catch (error){
        return error;
    }
}


//장애 처리현황
async function getErrStatic() {
    try{
        return  await needAuth.get('/statics/asset/type');
    }catch (error){
        return error;
    }
}

//작업 처리현환
async function getTaskStatic() {
    try{
        return  await needAuth.get('/statics/asset/type');
    }catch (error){
        return error;
    }
}


async function getSlaTotalRate(search) {
    try{
        return  await needAuth.post('/statics/sla/total-rate', search);
    }catch (error){
        return error;
    }
}

async function getSlaAccumulationRate(search) {
    try{
        return  await needAuth.post('/statics/sla/accumulation-rate', search);
    }catch (error){
        return error;
    }
}

async function getSlaEvaluationMonthRate(search) {
    try{
        return  await needAuth.post('/statics/sla/evaluation-rate', search);
    }catch (error){
        return error;
    }
}

async function getSlaAvailabilityRate(search) {
    try{
        return  await needAuth.post('/statics/sla/availability-rate', search);
    }catch (error){
        return error;
    }
}

async function getSlaIncidentRepeatCount(search) {
    try{
        return  await needAuth.post('/statics/sla/incident-repeat-count', search);
    }catch (error){
        return error;
    }
}

async function getSlaIncidentReportCount(search) {
    try{
        return  await needAuth.post('/statics/sla/incident-report-count', search);
    }catch (error){
        return error;
    }
}

async function getSlaMonthIncidentRecover(search) {
    try{
        return  await needAuth.post('/statics/sla/incident-recover', search);
    }catch (error){
        return error;
    }
}

async function getSlaMonthProcessRate(search) {
    try{
        return  await needAuth.post('/statics/sla/process-rate', search);
    }catch (error){
        return error;
    }
}

async function getSlaImproveAndLeak(search) {
    try{
        return  await needAuth.post('/statics/sla/improve-leak', search);
    }catch (error){
        return error;
    }
}



async function getAssetsOfCode(search, pageable) {
    console.log(search)
    try{
        const res = await needAuth.post('/assets?'+getPages(pageable),search);
        return  res;
    }catch (error){
        return error;
    }
}

export {
    //통합대시보드
    getMaintenancece,
    getMaintenanceceDetail,
    getTaskCalendar,
    getTaskCalendarList,
    getProcessCumulative,
    getKeepingRate,
    getServiceCurrent,
    getInDecreaseRateOfError,
    getSpreadOfError,
    getNotice,
    //자산대시보드
    getAssetByType,
    getAssetByCodeId,
    getAssetByDepartment,
    getAssetByProject,
    getAsseCurrent,
    getDepreciation,
    getContract,
    getSimmsLicense,
    getAssetDiligence,
    getAssetHistory,
    getErrStatic,
    getTaskStatic,
    getAssetLifeCycle,
    // SLA 대시보드
    getSlaTotalRate,
    getSlaAccumulationRate,
    getSlaIncidentReportCount,
    getSlaEvaluationMonthRate,
    getSlaMonthProcessRate,
    getSlaAvailabilityRate,
    getSlaImproveAndLeak,
    getSlaMonthIncidentRecover,
    getSlaIncidentRepeatCount,

    getAssetByParentId,
    getAssetsOfCode,
    
    // 유지보수 그룹, 업무, 업체, 코드별 현황
    getDataByParentIdAndTableName
};